// extracted by mini-css-extract-plugin
module.exports = {"qa":"QA-module--qa--24Eig","center":"QA-module--center--1W621"};